import { useQuery, UseQueryOptions } from 'react-query'
import { prop } from 'ramda'
import request, { Mutation, MutationOptions, useMakeMutation } from '@/services'
import useComapnyCode from '@/hooks/useComapnyCode'
import toQueryString from '@/utils/toQueryString'

export const useGetSSOLoginURL = (options?: UseQueryOptions<string>) => {
  const companyCode = useComapnyCode()

  const { data, isLoading, refetch } = useQuery<string>(
    ['/{companyCode}/sso/authServer', { companyCode }],
    {
      ...options,
      enabled: false,
      select: (res: any) => prop('data', res),
    }
  )

  return { data, isLoading, refetch }
}

export const useSSOVerify = (options: MutationOptions = {}): Mutation => {
  return useMakeMutation(
    (parmas: Record<string, any>) =>
      request(`/sso?${toQueryString(parmas)}`, {
        method: 'POST',
        displayMessage: false,
      }),
    options
  )
}
